import { Mail, Phone, MapPin } from 'lucide-react';
import { ContactDetail } from '../types';

export const contactDetails: ContactDetail[] = [
  {
    icon: Mail,
    label: 'Email',
    value: 'climatefinance-sustainabilitycentre@mubs.ac.ug',
    link: 'mailto:climatefinance-sustainabilitycentre@mubs.ac.ug'
  },
  {
    icon: Phone,
    label: 'Phone',
    value: '+256 757 710981',
    link: 'tel:+256757710981'
  },
  {
    icon: MapPin,
    label: 'Address',
    value: 'Climate Finance and Sustainability Centre, MUBS Main Building, 2nd Floor, Plot 21 A, Port Bell Rd, P.O Box 1337, Kampala, Uganda',
    link: 'https://maps.app.goo.gl/htcW57MuEtDUJw9C9'
  }
];
